<div mat-dialog-content class="w-timepicker-dialog">
    <w-time [color]="color" [hideMeridian]="hideMeridian" [userTime]="userTime" (onRevert)="revert()" (onSubmit)="submit()" [revertLabel]="data.revertLabel" [submitLabel]="data.submitLabel"></w-time>
</div>
